import { enqueueSnackbar } from 'notistack';
import { createAction } from 'redux-actions';

import { getMessage } from '@gef-ui/localization/messages';

import fetch from 'features/common/fetch';

import * as types from './actionTypes';
import { getInactiveData } from './selectors';

export const setData = createAction(types.SET_CAMPAIGN_ADDITIONAL_DATA, (data) => ({ data }));
export const updateData = createAction(types.UPDATE_CAMPAIGN_ADDITIONAL_DATA, (key, data) => ({ key, data }));
export const editData = createAction(types.EDIT_DATA, (key, text) => ({ key, text }));
export const activateData = createAction(types.ACTIVATE_DATA, (key) => ({ key }));
export const discardData = createAction(types.DISCARD_DATA, (key) => ({ key }));
export const revertChanges = createAction(types.REVERT_CHANGES);

export const fetchCampaignAdditionalData = (campaignId) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.campaignAdditionalData, {
			replaceParams: { id: campaignId },
			onSuccess: [
				(response) => () => {
					const additionalData = response.body;
					if (!additionalData || !Array.isArray(additionalData)) return;
					dispatch(setData(additionalData));
				},
			],
		}),
	);
};

export const saveCampaignAdditionalData = (campaignId, activeData) => (dispatch, getState) => {
	const inactiveData = getInactiveData(getState());
	dispatch(
		fetch.actions.put(fetch.constants.urls.campaignAdditionalData, {
			replaceParams: { id: campaignId },
			body: {
				additionalData: [...activeData, ...inactiveData],
			},
			onSuccess: [
				() => () => {
					enqueueSnackbar(getMessage('toastr:approveCampaignAdditionalData'), { variant: 'success' });
					dispatch(fetchCampaignAdditionalData(campaignId));
				},
			],
		}),
	);
};
